import { SEAT_TYPE } from "../../../utility/constants";

export function generateHorizontalSeats(row_number, column_number, seatType) {
    const seats = [];
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    for (let i = 1; i <= row_number; i++) {
        for (let j = 1; j <= column_number; j++) {
            if (j !== Math.ceil(column_number / 2)) {
                const seat = {
                    row_number: i,
                    column_number: j,
                    seat_name: `${alphabet[i - 1]}${
                        j > Math.ceil(column_number / 2) ? j - 1 : j
                    }`,
                    seat_type: seatType,
                    capacity: 1,
                };
                seats.push(seat);
            }
        }
    }
    return seats;
}

export function generateVerticalSeats(row_number, column_number, seatType) {
    const seats = [];

    for (let i = 1; i <= row_number; i++) {
        for (let j = 1; j <= column_number; j++) {
            if (j !== Math.ceil(column_number / 2)) {
                const seat = {
                    row_number: i,
                    column_number: j,
                    seat_name: `${i}${
                        j > Math.ceil(column_number / 2)
                            ? String.fromCharCode(64 + (j - 1))
                            : String.fromCharCode(64 + j)
                    }`,
                    seat_type: seatType,
                    capacity: 1,
                };
                seats.push(seat);
            }
        }
    }
    return seats;
}

export function findSeatIndexByName(seats, seat_name) {
    for (let i = 0; i < seats.length; i++) {
        if (seats[i].seat_name === seat_name) {
            return i;
        }
    }
    return -1; // Return -1 if no match is found
}

export const countDeckSeats = (decks = []) => {
    const deckSeatCount = {};
    decks.forEach((deck, index) => {
        let count = 0;
        if (deck && Object.hasOwnProperty.call(deck, "seats")) {
            count = deck.seats.length;
        }
        deckSeatCount[index] = count;
    });
    return deckSeatCount;
};

export const countTotalDeckSeats = (decks = []) => {
    let count = 0;
    decks.forEach((deck) => {
        if (deck && Object.hasOwnProperty.call(deck, "seats")) {
            count += deck.seats.length;
        }
    });
    return count;
};

export function addElementByRowColumn(array, newElement) {
    const newRowNumber = newElement.row_number;
    const newColumnNumber = newElement.column_number;

    let index = 0;
    for (let i = 0; i < array.length; i++) {
        const current = array[i];
        if (
            current.row_number === newRowNumber &&
            current.column_number > newColumnNumber
        ) {
            index = i;
            break;
        }
        if (current.row_number > newRowNumber) {
            index = i;
            break;
        }
        index = i + 1;
    }

    return [...array.slice(0, index), newElement, ...array.slice(index)];
}
